// Ô nhập giá trị chiết khấu đi cùng ô chọn kiểu: "đ" có phân cách nghìn, "%" nhận số lẻ (giữ chuỗi đang gõ như "14.")
import React, { useState } from 'react';
import type { DiscountType } from '../data';

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> {
  type: DiscountType;
  value: number;
  onChange: (value: number) => void;
}

export default function DiscountValueInput({ type, value, onChange, className = '', ...rest }: Props) {
  const [draft, setDraft] = useState<string | null>(null);
  const shown = draft ?? (value ? (type === 'đ' ? new Intl.NumberFormat('vi-VN').format(value) : String(value)) : '');
  return (
    <input
      type="text"
      inputMode={type === 'đ' ? 'numeric' : 'decimal'}
      autoComplete="off"
      value={shown}
      onFocus={e => e.target.select()}
      onBlur={() => setDraft(null)}
      onChange={e => {
        if (type === 'đ') {
          const digits = e.target.value.replace(/\D/g, '').slice(0, 13);
          setDraft(null);
          onChange(digits ? Number(digits) : 0);
          return;
        }
        const s = e.target.value.replace(',', '.').replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1').slice(0, 8);
        // Vượt 100% thì hiện 100 ngay (nơi gọi tự kẹp và báo)
        setDraft(Number(s) > 100 ? '100' : s);
        onChange(Number(s) || 0);
      }}
      className={`min-w-0 flex-1 border-none px-2 text-right outline-none ${className}`}
      {...rest}
    />
  );
}
